export default __webpack_public_path__ + "static/media/close_cross.b76126bb.svg";